import { render, staticRenderFns } from "./alfBrands.vue?vue&type=template&id=72709b9e&scoped=true&"
import script from "./alfBrands.vue?vue&type=script&lang=js&"
export * from "./alfBrands.vue?vue&type=script&lang=js&"
import style0 from "./alfBrands.vue?vue&type=style&index=0&id=72709b9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72709b9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72709b9e')) {
      api.createRecord('72709b9e', component.options)
    } else {
      api.reload('72709b9e', component.options)
    }
    module.hot.accept("./alfBrands.vue?vue&type=template&id=72709b9e&scoped=true&", function () {
      api.rerender('72709b9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/brands/alfBrands.vue"
export default component.exports